var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v(" EXPERIMENTAL PROCEDURE ")]),_c('h4',[_vm._v(" A mode of treatment or diagnostic procedure considered new and not widely accepted or utilized by the Philippine medical profession for which an equivalent traditional / conventional mode of treatment exists. ")])])
}]

export { render, staticRenderFns }